import apiFetch from "@wordpress/api-fetch";
import { useLocationStore } from "../state/storeLocation";
import { useGetMetaTune } from "./useGetMetaTune";
import { useGetMetaIqama } from "./useGetMetaIqama";
import { useGetMetaPrayerSettings } from "./useGetMetaPrayerSettings";
import { SelectSchemaValid } from "../validations/locationIsValid";
import { useGetMetaThemeColors } from "./useGetMetaThemeColors";
import { useGetMetaPrinter } from "./useGetMetaPrinter";
import { useGetMetaHijraLocale } from "./useGetMetaHijraLocale";
import useGetMetaRamadan from "./useGetMetaRamadan";
import { useTimeTableColor } from "../state/storeTimeTableColor";
import { useGetUrlLogoPrinter } from "./useGetUrlLogoPrinter";
import { UseEndPoints } from "./api/endpoints";

type Location = {
  value?: {
    id?: string | undefined;
    name?: string | undefined;
    method?: string | undefined;
  }[];
  "meta-key"?: string | undefined;
  id?: string | undefined;

  country?: string | undefined;
  city?: string | undefined;
  lat?: string | undefined;
  lng?: string | undefined;
};
export const useRefreshMetaData = () => {
  const { tuneMetaUpdate } = useGetMetaTune();
  const { iqamaMetaUpdate } = useGetMetaIqama();
  const { GetMetaPrayerSettings } = useGetMetaPrayerSettings();
  const { metaPrinter } = useGetMetaPrinter();
  const { GetMetaThemeColors } = useGetMetaThemeColors();
  const { updateCustomLocationData } = useLocationStore((state) => state);
  const {
    updateFirstBG,
    updateFirstText,
    updateSecondBG,
    updateSecondText,
    updateEvenBG,
    updateEvenText,
    updateOddBG,
    updateOddText,
    updateLightBG,
    updateLightText,
    updateBorderClr,
    updateBorderSize,
    updateBorderStyle,
  } = useTimeTableColor((state) => state);

  const SetASRCAL = useLocationStore((state) => state.updateSetASRCAL);
  const SetHighLittude = useLocationStore(
    (state) => state.updateSetHighLittude
  );
  const SetMCMode = useLocationStore((state) => state.updateSetMCMode);
  const SetMethodsForCal = useLocationStore(
    (state) => state.updateSetMethodsForCal
  );
  const { getMetaHijraLocale } = useGetMetaHijraLocale();
  const { getMetaRamadan } = useGetMetaRamadan();
  const { fetchPngUrl } = useGetUrlLogoPrinter();
  const defaultsColorTimeTable = () => {
    updateFirstBG({ r: 0, g: 184, b: 29, a: 1 });
    updateFirstText({ r: 255, g: 255, b: 255, a: 1 });
    updateSecondBG({ r: 80, g: 228, b: 19, a: 1 });
    updateSecondText({ r: 30, g: 0, b: 0, a: 1 });
    updateEvenBG({ r: 255, g: 255, b: 255, a: 1 });
    updateEvenText({ r: 3, g: 6, b: 20, a: 1 });
    updateOddBG({ r: 0, g: 138, b: 14, a: 1 });
    updateOddText({ r: 255, g: 255, b: 255, a: 1 });
    updateLightBG({ r: 242, g: 255, b: 0, a: 1 });
    updateLightText({ r: 201, g: 9, b: 9, a: 1 });
    updateBorderClr({ r: 33, g: 76, b: 10, a: 1 });
    updateBorderSize(1);
    updateBorderStyle("solid");
  };
  const getPrayerSettingMeta = async () => {
    const endpoint = UseEndPoints();
    try {
      const posts: SelectSchemaValid[] = await apiFetch({
        path: `${endpoint}/fp_prayersettings_meta`,
      });
      defaultsColorTimeTable();
      fetchPngUrl();
      for (const meta of posts) {
        if (
          meta["meta-key"] === "midnight_calculation_mode" &&
          meta?.value &&
          typeof meta?.value === "string"
        ) {
          const converter: SelectSchemaValid = {
            id: meta.id,
            "meta-key": meta["meta-key"],
            value: JSON.parse(meta?.value),
          };
          SetMCMode(converter);
        }
        if (
          meta["meta-key"] === "Only_affects_Asr_calculation" &&
          meta?.value &&
          typeof meta?.value === "string"
        ) {
          const converter: SelectSchemaValid = {
            id: meta.id,
            "meta-key": meta["meta-key"],
            value: JSON.parse(meta?.value),
          };
          SetASRCAL(converter);
        }
        if (
          meta["meta-key"] === "Higher_Latitudes_Methods" &&
          meta?.value &&
          typeof meta?.value === "string"
        ) {
          const converter: SelectSchemaValid = {
            id: meta.id,
            "meta-key": meta["meta-key"],
            value: JSON.parse(meta?.value),
          };
          SetHighLittude(converter);
        }
        if (
          meta["meta-key"] === "Methods_For_Calculation" &&
          meta?.value &&
          typeof meta?.value === "string"
        ) {
          const converter: SelectSchemaValid = {
            id: meta.id,
            "meta-key": meta["meta-key"],
            value: JSON.parse(meta?.value),
          };
          SetMethodsForCal(converter);
        }

        if (meta["meta-key"] === "location_list") {
          const converter: Location = {
            id: meta.id,
            "meta-key": meta["meta-key"],
            value: JSON.parse([meta.value].toString()),
          };
          updateCustomLocationData(converter);
        }

        metaPrinter(meta);
        GetMetaPrayerSettings(meta);
        tuneMetaUpdate(meta);
        iqamaMetaUpdate(meta);
        GetMetaThemeColors(meta);
        getMetaHijraLocale(meta);
        getMetaRamadan(meta);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return { getPrayerSettingMeta };
};
